module.exports = __webpack_public_path__ + "media/images/project/follow-up-aad17d61f046187a3cb264e1d952f391.svg";